interface NavigateFunction {
  (
    to: any,
    options?: {
      replace?: boolean;
      state?: any;
      relative?: any;
    },
  ): void;
  (delta: number): void;
}

export const handleActions = (action: string, props: any, navigate: NavigateFunction, context: any, e: any) => {
  switch (action) {
    case 'logout':
      e.preventDefault();
      console.log('TODO: implement logout action');
      break;

    case 'page_go_back_action':
      e.preventDefault();
      navigate(-1);
      break;

    // TODO : other cases
    default:
      console.log('handleActions', { action, props, context });
    /* */
  }
};
